import {useDispatch, useSelector} from 'react-redux'

import ModalCustom from '../../ui/modal/ModalCustom'
import Loader from '../../ui/loader/Loader'
import CancellationModalContent from './CancellationModalContent'
import {
  selectShoppersModals,
  showCancellationShoppersModal,
} from '../../../slice/shoppersModalsSlice'

interface CancellationModalInterface {
    handleCancellationModal: Function,
    executions: any[]|Object,
}

const CancellationModal = ({handleCancellationModal, executions}: CancellationModalInterface) => {
  const dispatch = useDispatch()
  const {cancellationShow, cancelBtnClass, loading} = useSelector(
    selectShoppersModals,
  )

  /** Ouvre la modale permettant de supprimer un prebook */
  const handleShopperCancellationOnHide = () => {
    dispatch(showCancellationShoppersModal({show: false}))
  }

  return (
    <>
      <ModalCustom
        id={'shopperCancellationModal'}
        title="Annulation de livraison"
        titleClassname="text-center mb-3"
        bodyClassname="text-left"
        footer={true}
        show={cancellationShow}
        onHide={handleShopperCancellationOnHide}
        buttonsFooter={[
          {
            text: 'Annuler la livraison',
            onClick: handleCancellationModal,
            classNames: cancelBtnClass,
          },
          {
            text: 'Fermer',
            onClick: handleShopperCancellationOnHide,
          },
        ]}
        content={
          !loading ? (
            <CancellationModalContent executions={executions} />
          ) : (
            <Loader />
          )
        }
      />
    </>
  )
}

export default CancellationModal
